import { render, staticRenderFns } from "./embed-token.vue?vue&type=template&id=b2664000&scoped=true&"
import script from "./embed-token.vue?vue&type=script&lang=ts&"
export * from "./embed-token.vue?vue&type=script&lang=ts&"
import style0 from "./embed-token.vue?vue&type=style&index=0&id=b2664000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2664000",
  null
  
)

export default component.exports